import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-duigou",
  "use": "icon-duigou-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-duigou\"><defs><style type=\"text/css\"></style></defs><path d=\"M248 358.6c-34-34.8-89.7-35.4-124.5-1.4s-35.4 89.7-1.4 124.5L450.9 818l451-461.4c34-34.8 33.4-90.5-1.4-124.5S810 198.7 776 233.5L450.9 566.1 248 358.6z\" fill=\"#EE2233\" p-id=\"18383\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol